import configData from './configData.json';

const configService = {
  data: configData as { [key: string]: any },
};

export default configService;
